import { getDecryptedItem, setEncryptedItem } from "../encryptedStorage";

const THEME_STORAGE_KEY = "themeConfig";

export function saveThemeConfig(config) {
  if (config) {
    try {
      setEncryptedItem(THEME_STORAGE_KEY, JSON.stringify(config));
    } catch (err) {
      console.error("Failed to save theme config to storage:", err);
    }
  } else {
    localStorage.removeItem(THEME_STORAGE_KEY);
  }
}

export function getThemeConfig() {
  const data = getDecryptedItem(THEME_STORAGE_KEY);
  if (!data) return null;

  try {
    return JSON.parse(data);
  } catch (err) {
    console.error("Failed to parse theme config from storage:", err);
    return null;
  }
}

// TODO- Will customize this func, as of now it's half working stopped by scss - build failing
export function applyThemeStyles(config) {
  // if (!config) return;
  // document.documentElement.style.setProperty("--primary", config.primaryColor);
  // document.documentElement.style.setProperty(
  //   "--secondary",
  //   config.secondaryColor
  // );
  // document.documentElement.style.setProperty("--accent", config.accentColor);
  // document.documentElement.style.setProperty(
  //   "--font-family-sans-serif",
  //   config.fontFamily
  // );
  // if (config.customCss) {
  //   const style = document.createElement("style");
  //   style.innerHTML = config.customCss;
  //   document.head.appendChild(style);
  // }
}
